import react from "react";
import "./admin.css";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AdminTour from "./components/AdminTour";
import AdminTabs from "./components/AdminTabs";
import { clearAdminDirty, getAdminDirtyLabel, isAdminDirty } from "./adminDirty";

const BACK_BY_PATH = {
  "/admin/rules": { to: "/admin/", label: "Back" },
  "/admin/customize-spot": { to: "/admin/rules", label: "Back" },
  "/admin/jury": { to: "/admin/rules", label: "Back" },
  "/admin/uploads": { to: "/admin/rules", label: "Back to rules" },
  "/admin/mosaic": { to: "/admin/rules", label: "Back to rules" },
};

function Admin({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const raw = location.pathname;
  const cleaned = raw.endsWith("/") && raw !== "/" ? raw.slice(0, -1) : raw;
  const back = BACK_BY_PATH[cleaned] || null;

  const redirectGameSession = () => {
    let getGameId = JSON.parse(localStorage.getItem("userData"));
    getGameId = getGameId.gameId;
    window.location.href =
      process.env.REACT_APP_BASE_URL + "/active-games/" + getGameId;
  };

  const handleBack = async () => {
    if (!back) return;
    if (isAdminDirty()) {
      const label = getAdminDirtyLabel();
      const result = await Swal.fire({
        title: "Unsaved changes",
        text: label
          ? `Please save your changes on ${label} before leaving.`
          : "Please save your changes before leaving this page.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Leave without saving",
        cancelButtonText: "Stay",
        confirmButtonColor: "#E25569",
      });
      if (!result.isConfirmed) return;
      clearAdminDirty();
    }
    navigate(back.to);
  };

  return (
    <div className="admin-background">
      <div className="header-admin">
        <div className="brand-logo-and-game-holder">
          <div
            className="brand-logo-holder"
            onClick={() => {
              window.location.href = process.env.REACT_APP_BASE_URL;
            }}
          >
            <img src="/admin/play.png" className="brand-logo" alt="Play" />
            {localStorage.getItem("session") === "admin&admin" && " SUPERADMIN"}
          </div>
          <div onClick={() => redirectGameSession()}>We got talent </div>
        </div>

        <div className="header-admin-right">
          <div className="user">
            <img src="/admin/user.png" alt="" />
          </div>
        </div>
      </div>
      <AdminTabs />
      <div className="admin-page-bar">
        <div className="admin-page-bar-left">
          {back ? (
            <button type="button" className="back-button" onClick={handleBack}>
              <i className="fa-solid fa-arrow-left" /> {back.label}
            </button>
          ) : (
            <span className="admin-page-bar-spacer" />
          )}
        </div>
        <div className="admin-page-bar-right">
          <AdminTour />
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
}

export default Admin;
